import { default as aboutQf3wUgED7YMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsrOhd4uABpHMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93xnIv727A4RMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampled1WNLcYWvpMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsOnrWAjV3HLMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93lQwLJhZI8gMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewpYoMDKZPpfMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index5Y8YPAheRkMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93TYWoLtowfIMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexkXCoPZls24Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93NGHnQBiW70Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexxl1ouhKebCMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionslTB7Mw8Z5XMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsshPe6OENEJMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsf4HHIwQnZJMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93KhfvfrLOOKMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexowZz7WVn12Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmmhvzcvO2TbMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmaVyDw76FnHMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarzIl3V4bxWyMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatcR5tbbuREmMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutII35nHMSMAMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedw5exnc1u0TMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersnYvkz3YFNhMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93zu0C4hnoDpMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editcaJ0ObACd5Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93bHGAdCGCwQMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityaNM4MXOKrfMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_930DYdGWZSiAMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93ZSuO9Ls0uyMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardeAunTgoO3jMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexg025hXd0lcMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutx90p2lx3JhMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productzdGUgVJesJMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as events1hVTasOJoJMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93KIVVaoYYEcMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexfdpr0M73r4Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93UbQe7fgfT6Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93PaOg2vCWErMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexKhzm4R6l9yMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93eJt9U1hqBxMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinHbQH9Qg99oMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/join.vue?macro=true";
import { default as loginyz3rGUIhPtMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/login.vue?macro=true";
import { default as logoutk7n4FLBaGJMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_933R9JKHBgF3Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93kBxni6Yqj2Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93OaRiUddRL9Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesiLKfVww0xnMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studios3DqXdxkAF7Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinnTHXHMCWQqMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93L566qluatoMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexOxhJcLLvOYMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as index9QrdmIkYZIMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutLxMEmEPB7bMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentCc2RQIZMKHMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as events5cGO7REAyxMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93zrFLP8axOOMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplejG3fRgbJquMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsWdjNVarYUcMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_938xUAaJZD7iMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewRdeN0l97KYMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexOTAigEsppMMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93vH28WYwAGSMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexwTyrYqMzGuMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93khuCGJ5IUtMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexWrjWwWLF7pMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessions6if6xp9ouQMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsWZRPha4MB5Meta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsly7o3WTV5sMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93qFzB2mcoOZMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as index4TnvwIi7TvMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/product/index.vue?macro=true";
import { default as index0qrHz0BeHJMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesagYm5nMvzDMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsRPfhfIycuFMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93YtxyMuNSqOMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93SkGOJ5bnlYMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as reset1XN5iM5PTqMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/reset.vue?macro=true";
import { default as shopQBBkBLGyyTMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/shop.vue?macro=true";
import { default as signupFfmt9AEaneMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/signup.vue?macro=true";
import { default as live3K3U5S95JqMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsAZJcqEHHveMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93mAWIggzBKMMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactR1PeyY0syjMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as full3MLsiv5BcWMeta } from "/tmp/build_745d8f7f/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93KhfvfrLOOKMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93KhfvfrLOOKMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93KhfvfrLOOKMeta || {},
    alias: _91product_id_93KhfvfrLOOKMeta?.alias || [],
    redirect: _91product_id_93KhfvfrLOOKMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutQf3wUgED7YMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutQf3wUgED7YMeta?.path ?? "about",
    meta: aboutQf3wUgED7YMeta || {},
    alias: aboutQf3wUgED7YMeta?.alias || [],
    redirect: aboutQf3wUgED7YMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsrOhd4uABpHMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsrOhd4uABpHMeta?.path ?? "events",
    meta: eventsrOhd4uABpHMeta || {},
    alias: eventsrOhd4uABpHMeta?.alias || [],
    redirect: eventsrOhd4uABpHMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93xnIv727A4RMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93xnIv727A4RMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93xnIv727A4RMeta || {},
    alias: _91media_id_93xnIv727A4RMeta?.alias || [],
    redirect: _91media_id_93xnIv727A4RMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampled1WNLcYWvpMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampled1WNLcYWvpMeta?.path ?? "free-sample",
    meta: free_45sampled1WNLcYWvpMeta || {},
    alias: free_45sampled1WNLcYWvpMeta?.alias || [],
    redirect: free_45sampled1WNLcYWvpMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsOnrWAjV3HLMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsOnrWAjV3HLMeta?.path ?? "included-products",
    meta: included_45productsOnrWAjV3HLMeta || {},
    alias: included_45productsOnrWAjV3HLMeta?.alias || [],
    redirect: included_45productsOnrWAjV3HLMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93lQwLJhZI8gMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93lQwLJhZI8gMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93lQwLJhZI8gMeta || {},
    alias: _91media_id_93lQwLJhZI8gMeta?.alias || [],
    redirect: _91media_id_93lQwLJhZI8gMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewpYoMDKZPpfMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewpYoMDKZPpfMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewpYoMDKZPpfMeta || {},
    alias: viewpYoMDKZPpfMeta?.alias || [],
    redirect: viewpYoMDKZPpfMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index5Y8YPAheRkMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: index5Y8YPAheRkMeta?.path ?? "lessons",
    meta: index5Y8YPAheRkMeta || {},
    alias: index5Y8YPAheRkMeta?.alias || [],
    redirect: index5Y8YPAheRkMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93TYWoLtowfIMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93TYWoLtowfIMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93TYWoLtowfIMeta || {},
    alias: _91media_id_93TYWoLtowfIMeta?.alias || [],
    redirect: _91media_id_93TYWoLtowfIMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexkXCoPZls24Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexkXCoPZls24Meta?.path ?? "playlists/:playlist_id()",
    meta: indexkXCoPZls24Meta || {},
    alias: indexkXCoPZls24Meta?.alias || [],
    redirect: indexkXCoPZls24Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93NGHnQBiW70Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93NGHnQBiW70Meta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93NGHnQBiW70Meta || {},
    alias: _91media_id_93NGHnQBiW70Meta?.alias || [],
    redirect: _91media_id_93NGHnQBiW70Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexxl1ouhKebCMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexxl1ouhKebCMeta?.path ?? "playlists",
    meta: indexxl1ouhKebCMeta || {},
    alias: indexxl1ouhKebCMeta?.alias || [],
    redirect: indexxl1ouhKebCMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionslTB7Mw8Z5XMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionslTB7Mw8Z5XMeta?.path ?? "private-sessions",
    meta: private_45sessionslTB7Mw8Z5XMeta || {},
    alias: private_45sessionslTB7Mw8Z5XMeta?.alias || [],
    redirect: private_45sessionslTB7Mw8Z5XMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsshPe6OENEJMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsshPe6OENEJMeta?.path ?? "recordings",
    meta: recordingsshPe6OENEJMeta || {},
    alias: recordingsshPe6OENEJMeta?.alias || [],
    redirect: recordingsshPe6OENEJMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsf4HHIwQnZJMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsf4HHIwQnZJMeta?.path ?? "reviews",
    meta: reviewsf4HHIwQnZJMeta || {},
    alias: reviewsf4HHIwQnZJMeta?.alias || [],
    redirect: reviewsf4HHIwQnZJMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexowZz7WVn12Meta?.name ?? "buy-product-product_id",
    path: indexowZz7WVn12Meta?.path ?? "/buy/product/:product_id()",
    meta: indexowZz7WVn12Meta || {},
    alias: indexowZz7WVn12Meta?.alias || [],
    redirect: indexowZz7WVn12Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmmhvzcvO2TbMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmmhvzcvO2TbMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmmhvzcvO2TbMeta || {},
    alias: confirmmhvzcvO2TbMeta?.alias || [],
    redirect: confirmmhvzcvO2TbMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmaVyDw76FnHMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmaVyDw76FnHMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmaVyDw76FnHMeta || {},
    alias: confirmaVyDw76FnHMeta?.alias || [],
    redirect: confirmaVyDw76FnHMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarzIl3V4bxWyMeta?.name ?? "calendar",
    path: calendarzIl3V4bxWyMeta?.path ?? "/calendar",
    meta: calendarzIl3V4bxWyMeta || {},
    alias: calendarzIl3V4bxWyMeta?.alias || [],
    redirect: calendarzIl3V4bxWyMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatcR5tbbuREmMeta?.name ?? "chat",
    path: chatcR5tbbuREmMeta?.path ?? "/chat",
    meta: chatcR5tbbuREmMeta || {},
    alias: chatcR5tbbuREmMeta?.alias || [],
    redirect: chatcR5tbbuREmMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93zu0C4hnoDpMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93zu0C4hnoDpMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93zu0C4hnoDpMeta || {},
    alias: _91group_id_93zu0C4hnoDpMeta?.alias || [],
    redirect: _91group_id_93zu0C4hnoDpMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutII35nHMSMAMeta?.name ?? "community-groups-group_id-about",
    path: aboutII35nHMSMAMeta?.path ?? "about",
    meta: aboutII35nHMSMAMeta || {},
    alias: aboutII35nHMSMAMeta?.alias || [],
    redirect: aboutII35nHMSMAMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedw5exnc1u0TMeta?.name ?? "community-groups-group_id-feed",
    path: feedw5exnc1u0TMeta?.path ?? "feed",
    meta: feedw5exnc1u0TMeta || {},
    alias: feedw5exnc1u0TMeta?.alias || [],
    redirect: feedw5exnc1u0TMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersnYvkz3YFNhMeta?.name ?? "community-groups-group_id-members",
    path: membersnYvkz3YFNhMeta?.path ?? "members",
    meta: membersnYvkz3YFNhMeta || {},
    alias: membersnYvkz3YFNhMeta?.alias || [],
    redirect: membersnYvkz3YFNhMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editcaJ0ObACd5Meta?.name ?? "community-profile-edit",
    path: community_45profile_45editcaJ0ObACd5Meta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editcaJ0ObACd5Meta || {},
    alias: community_45profile_45editcaJ0ObACd5Meta?.alias || [],
    redirect: community_45profile_45editcaJ0ObACd5Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93bHGAdCGCwQMeta?.name ?? "community-profile-id",
    path: _91id_93bHGAdCGCwQMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93bHGAdCGCwQMeta || {},
    alias: _91id_93bHGAdCGCwQMeta?.alias || [],
    redirect: _91id_93bHGAdCGCwQMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityaNM4MXOKrfMeta?.name ?? "community",
    path: communityaNM4MXOKrfMeta?.path ?? "/community",
    meta: communityaNM4MXOKrfMeta || {},
    alias: communityaNM4MXOKrfMeta?.alias || [],
    redirect: communityaNM4MXOKrfMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_930DYdGWZSiAMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_930DYdGWZSiAMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_930DYdGWZSiAMeta || {},
    alias: _91uuid_930DYdGWZSiAMeta?.alias || [],
    redirect: _91uuid_930DYdGWZSiAMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93ZSuO9Ls0uyMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93ZSuO9Ls0uyMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93ZSuO9Ls0uyMeta || {},
    alias: _91unique_id_93ZSuO9Ls0uyMeta?.alias || [],
    redirect: _91unique_id_93ZSuO9Ls0uyMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardeAunTgoO3jMeta?.name ?? "dashboard",
    path: dashboardeAunTgoO3jMeta?.path ?? "/dashboard",
    meta: dashboardeAunTgoO3jMeta || {},
    alias: dashboardeAunTgoO3jMeta?.alias || [],
    redirect: dashboardeAunTgoO3jMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexg025hXd0lcMeta?.name ?? "event-details-event_id",
    path: indexg025hXd0lcMeta?.path ?? "/event/details/:event_id()",
    meta: indexg025hXd0lcMeta || {},
    alias: indexg025hXd0lcMeta?.alias || [],
    redirect: indexg025hXd0lcMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutx90p2lx3JhMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutx90p2lx3JhMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutx90p2lx3JhMeta || {},
    alias: checkoutx90p2lx3JhMeta?.alias || [],
    redirect: checkoutx90p2lx3JhMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productzdGUgVJesJMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productzdGUgVJesJMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productzdGUgVJesJMeta || {},
    alias: select_45productzdGUgVJesJMeta?.alias || [],
    redirect: select_45productzdGUgVJesJMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: events1hVTasOJoJMeta?.name ?? "events",
    path: events1hVTasOJoJMeta?.path ?? "/events",
    meta: events1hVTasOJoJMeta || {},
    alias: events1hVTasOJoJMeta?.alias || [],
    redirect: events1hVTasOJoJMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93KIVVaoYYEcMeta?.name ?? "gifts-uuid",
    path: _91uuid_93KIVVaoYYEcMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93KIVVaoYYEcMeta || {},
    alias: _91uuid_93KIVVaoYYEcMeta?.alias || [],
    redirect: _91uuid_93KIVVaoYYEcMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexfdpr0M73r4Meta?.name ?? "gifts",
    path: indexfdpr0M73r4Meta?.path ?? "/gifts",
    meta: indexfdpr0M73r4Meta || {},
    alias: indexfdpr0M73r4Meta?.alias || [],
    redirect: indexfdpr0M73r4Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93UbQe7fgfT6Meta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93UbQe7fgfT6Meta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93UbQe7fgfT6Meta || {},
    alias: _91invitation_id_93UbQe7fgfT6Meta?.alias || [],
    redirect: _91invitation_id_93UbQe7fgfT6Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93PaOg2vCWErMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93PaOg2vCWErMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93PaOg2vCWErMeta || {},
    alias: _91product_id_93PaOg2vCWErMeta?.alias || [],
    redirect: _91product_id_93PaOg2vCWErMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexKhzm4R6l9yMeta?.name ?? "index",
    path: indexKhzm4R6l9yMeta?.path ?? "/",
    meta: indexKhzm4R6l9yMeta || {},
    alias: indexKhzm4R6l9yMeta?.alias || [],
    redirect: indexKhzm4R6l9yMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93eJt9U1hqBxMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93eJt9U1hqBxMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93eJt9U1hqBxMeta || {},
    alias: _91invitation_unique_id_93eJt9U1hqBxMeta?.alias || [],
    redirect: _91invitation_unique_id_93eJt9U1hqBxMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinHbQH9Qg99oMeta?.name ?? "join",
    path: joinHbQH9Qg99oMeta?.path ?? "/join",
    meta: joinHbQH9Qg99oMeta || {},
    alias: joinHbQH9Qg99oMeta?.alias || [],
    redirect: joinHbQH9Qg99oMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginyz3rGUIhPtMeta?.name ?? "login",
    path: loginyz3rGUIhPtMeta?.path ?? "/login",
    meta: loginyz3rGUIhPtMeta || {},
    alias: loginyz3rGUIhPtMeta?.alias || [],
    redirect: loginyz3rGUIhPtMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutk7n4FLBaGJMeta?.name ?? "logout",
    path: logoutk7n4FLBaGJMeta?.path ?? "/logout",
    meta: logoutk7n4FLBaGJMeta || {},
    alias: logoutk7n4FLBaGJMeta?.alias || [],
    redirect: logoutk7n4FLBaGJMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_933R9JKHBgF3Meta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_933R9JKHBgF3Meta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_933R9JKHBgF3Meta || {},
    alias: _91meeting_type_slug_933R9JKHBgF3Meta?.alias || [],
    redirect: _91meeting_type_slug_933R9JKHBgF3Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93kBxni6Yqj2Meta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93kBxni6Yqj2Meta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93kBxni6Yqj2Meta || {},
    alias: _91meeting_unique_id_93kBxni6Yqj2Meta?.alias || [],
    redirect: _91meeting_unique_id_93kBxni6Yqj2Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93OaRiUddRL9Meta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93OaRiUddRL9Meta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93OaRiUddRL9Meta || {},
    alias: _91meeting_unique_id_93OaRiUddRL9Meta?.alias || [],
    redirect: _91meeting_unique_id_93OaRiUddRL9Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesiLKfVww0xnMeta?.name ?? "my-favorites",
    path: my_45favoritesiLKfVww0xnMeta?.path ?? "/my-favorites",
    meta: my_45favoritesiLKfVww0xnMeta || {},
    alias: my_45favoritesiLKfVww0xnMeta?.alias || [],
    redirect: my_45favoritesiLKfVww0xnMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studios3DqXdxkAF7Meta?.name ?? "my-studios",
    path: my_45studios3DqXdxkAF7Meta?.path ?? "/my-studios",
    meta: my_45studios3DqXdxkAF7Meta || {},
    alias: my_45studios3DqXdxkAF7Meta?.alias || [],
    redirect: my_45studios3DqXdxkAF7Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinnTHXHMCWQqMeta?.name ?? "optin",
    path: optinnTHXHMCWQqMeta?.path ?? "/optin",
    meta: optinnTHXHMCWQqMeta || {},
    alias: optinnTHXHMCWQqMeta?.alias || [],
    redirect: optinnTHXHMCWQqMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93L566qluatoMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93L566qluatoMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93L566qluatoMeta || {},
    alias: _91episode_id_93L566qluatoMeta?.alias || [],
    redirect: _91episode_id_93L566qluatoMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexOxhJcLLvOYMeta?.name ?? "podcasts-podcast_id",
    path: indexOxhJcLLvOYMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexOxhJcLLvOYMeta || {},
    alias: indexOxhJcLLvOYMeta?.alias || [],
    redirect: indexOxhJcLLvOYMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: index9QrdmIkYZIMeta?.name ?? "podcasts",
    path: index9QrdmIkYZIMeta?.path ?? "/podcasts",
    meta: index9QrdmIkYZIMeta || {},
    alias: index9QrdmIkYZIMeta?.alias || [],
    redirect: index9QrdmIkYZIMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93qFzB2mcoOZMeta?.name ?? "product-product_id",
    path: _91product_id_93qFzB2mcoOZMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93qFzB2mcoOZMeta || {},
    alias: _91product_id_93qFzB2mcoOZMeta?.alias || [],
    redirect: _91product_id_93qFzB2mcoOZMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutLxMEmEPB7bMeta?.name ?? "product-product_id-about",
    path: aboutLxMEmEPB7bMeta?.path ?? "about",
    meta: aboutLxMEmEPB7bMeta || {},
    alias: aboutLxMEmEPB7bMeta?.alias || [],
    redirect: aboutLxMEmEPB7bMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentCc2RQIZMKHMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentCc2RQIZMKHMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentCc2RQIZMKHMeta || {},
    alias: digital_45download_45contentCc2RQIZMKHMeta?.alias || [],
    redirect: digital_45download_45contentCc2RQIZMKHMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: events5cGO7REAyxMeta?.name ?? "product-product_id-events",
    path: events5cGO7REAyxMeta?.path ?? "events",
    meta: events5cGO7REAyxMeta || {},
    alias: events5cGO7REAyxMeta?.alias || [],
    redirect: events5cGO7REAyxMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93zrFLP8axOOMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93zrFLP8axOOMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93zrFLP8axOOMeta || {},
    alias: _91media_id_93zrFLP8axOOMeta?.alias || [],
    redirect: _91media_id_93zrFLP8axOOMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplejG3fRgbJquMeta?.name ?? "product-product_id-free-sample",
    path: free_45samplejG3fRgbJquMeta?.path ?? "free-sample",
    meta: free_45samplejG3fRgbJquMeta || {},
    alias: free_45samplejG3fRgbJquMeta?.alias || [],
    redirect: free_45samplejG3fRgbJquMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsWdjNVarYUcMeta?.name ?? "product-product_id-included-products",
    path: included_45productsWdjNVarYUcMeta?.path ?? "included-products",
    meta: included_45productsWdjNVarYUcMeta || {},
    alias: included_45productsWdjNVarYUcMeta?.alias || [],
    redirect: included_45productsWdjNVarYUcMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_938xUAaJZD7iMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_938xUAaJZD7iMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_938xUAaJZD7iMeta || {},
    alias: _91media_id_938xUAaJZD7iMeta?.alias || [],
    redirect: _91media_id_938xUAaJZD7iMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewRdeN0l97KYMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewRdeN0l97KYMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewRdeN0l97KYMeta || {},
    alias: viewRdeN0l97KYMeta?.alias || [],
    redirect: viewRdeN0l97KYMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexOTAigEsppMMeta?.name ?? "product-product_id-lessons",
    path: indexOTAigEsppMMeta?.path ?? "lessons",
    meta: indexOTAigEsppMMeta || {},
    alias: indexOTAigEsppMMeta?.alias || [],
    redirect: indexOTAigEsppMMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93vH28WYwAGSMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93vH28WYwAGSMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93vH28WYwAGSMeta || {},
    alias: _91media_id_93vH28WYwAGSMeta?.alias || [],
    redirect: _91media_id_93vH28WYwAGSMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexwTyrYqMzGuMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexwTyrYqMzGuMeta?.path ?? "playlists/:playlist_id()",
    meta: indexwTyrYqMzGuMeta || {},
    alias: indexwTyrYqMzGuMeta?.alias || [],
    redirect: indexwTyrYqMzGuMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93khuCGJ5IUtMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93khuCGJ5IUtMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93khuCGJ5IUtMeta || {},
    alias: _91media_id_93khuCGJ5IUtMeta?.alias || [],
    redirect: _91media_id_93khuCGJ5IUtMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexWrjWwWLF7pMeta?.name ?? "product-product_id-playlists",
    path: indexWrjWwWLF7pMeta?.path ?? "playlists",
    meta: indexWrjWwWLF7pMeta || {},
    alias: indexWrjWwWLF7pMeta?.alias || [],
    redirect: indexWrjWwWLF7pMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessions6if6xp9ouQMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessions6if6xp9ouQMeta?.path ?? "private-sessions",
    meta: private_45sessions6if6xp9ouQMeta || {},
    alias: private_45sessions6if6xp9ouQMeta?.alias || [],
    redirect: private_45sessions6if6xp9ouQMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsWZRPha4MB5Meta?.name ?? "product-product_id-recordings",
    path: recordingsWZRPha4MB5Meta?.path ?? "recordings",
    meta: recordingsWZRPha4MB5Meta || {},
    alias: recordingsWZRPha4MB5Meta?.alias || [],
    redirect: recordingsWZRPha4MB5Meta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsly7o3WTV5sMeta?.name ?? "product-product_id-reviews",
    path: reviewsly7o3WTV5sMeta?.path ?? "reviews",
    meta: reviewsly7o3WTV5sMeta || {},
    alias: reviewsly7o3WTV5sMeta?.alias || [],
    redirect: reviewsly7o3WTV5sMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index4TnvwIi7TvMeta?.name ?? "product",
    path: index4TnvwIi7TvMeta?.path ?? "/product",
    meta: index4TnvwIi7TvMeta || {},
    alias: index4TnvwIi7TvMeta?.alias || [],
    redirect: index4TnvwIi7TvMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: index0qrHz0BeHJMeta?.name ?? "profile",
    path: index0qrHz0BeHJMeta?.path ?? "/profile",
    meta: index0qrHz0BeHJMeta || {},
    alias: index0qrHz0BeHJMeta?.alias || [],
    redirect: index0qrHz0BeHJMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesagYm5nMvzDMeta?.name ?? "profile-purchases",
    path: purchasesagYm5nMvzDMeta?.path ?? "/profile/purchases",
    meta: purchasesagYm5nMvzDMeta || {},
    alias: purchasesagYm5nMvzDMeta?.alias || [],
    redirect: purchasesagYm5nMvzDMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsRPfhfIycuFMeta?.name ?? "profile-redemptions",
    path: redemptionsRPfhfIycuFMeta?.path ?? "/profile/redemptions",
    meta: redemptionsRPfhfIycuFMeta || {},
    alias: redemptionsRPfhfIycuFMeta?.alias || [],
    redirect: redemptionsRPfhfIycuFMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93YtxyMuNSqOMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93YtxyMuNSqOMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93YtxyMuNSqOMeta || {},
    alias: _91quiz_id_93YtxyMuNSqOMeta?.alias || [],
    redirect: _91quiz_id_93YtxyMuNSqOMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93SkGOJ5bnlYMeta?.name ?? "reset-password-uid-token",
    path: _91token_93SkGOJ5bnlYMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93SkGOJ5bnlYMeta || {},
    alias: _91token_93SkGOJ5bnlYMeta?.alias || [],
    redirect: _91token_93SkGOJ5bnlYMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: reset1XN5iM5PTqMeta?.name ?? "reset",
    path: reset1XN5iM5PTqMeta?.path ?? "/reset",
    meta: reset1XN5iM5PTqMeta || {},
    alias: reset1XN5iM5PTqMeta?.alias || [],
    redirect: reset1XN5iM5PTqMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopQBBkBLGyyTMeta?.name ?? "shop",
    path: shopQBBkBLGyyTMeta?.path ?? "/shop",
    meta: shopQBBkBLGyyTMeta || {},
    alias: shopQBBkBLGyyTMeta?.alias || [],
    redirect: shopQBBkBLGyyTMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupFfmt9AEaneMeta?.name ?? "signup",
    path: signupFfmt9AEaneMeta?.path ?? "/signup",
    meta: signupFfmt9AEaneMeta || {},
    alias: signupFfmt9AEaneMeta?.alias || [],
    redirect: signupFfmt9AEaneMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: live3K3U5S95JqMeta?.name ?? "streaming-event_id-live",
    path: live3K3U5S95JqMeta?.path ?? "/streaming/:event_id()/live",
    meta: live3K3U5S95JqMeta || {},
    alias: live3K3U5S95JqMeta?.alias || [],
    redirect: live3K3U5S95JqMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsAZJcqEHHveMeta?.name ?? "tips",
    path: tipsAZJcqEHHveMeta?.path ?? "/tips",
    meta: tipsAZJcqEHHveMeta || {},
    alias: tipsAZJcqEHHveMeta?.alias || [],
    redirect: tipsAZJcqEHHveMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93mAWIggzBKMMeta?.name ?? "waiver-uuid",
    path: _91uuid_93mAWIggzBKMMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93mAWIggzBKMMeta || {},
    alias: _91uuid_93mAWIggzBKMMeta?.alias || [],
    redirect: _91uuid_93mAWIggzBKMMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactR1PeyY0syjMeta?.name ?? "widgets-calendars-compact",
    path: compactR1PeyY0syjMeta?.path ?? "/widgets/calendars/compact",
    meta: compactR1PeyY0syjMeta || {},
    alias: compactR1PeyY0syjMeta?.alias || [],
    redirect: compactR1PeyY0syjMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: full3MLsiv5BcWMeta?.name ?? "widgets-calendars-full",
    path: full3MLsiv5BcWMeta?.path ?? "/widgets/calendars/full",
    meta: full3MLsiv5BcWMeta || {},
    alias: full3MLsiv5BcWMeta?.alias || [],
    redirect: full3MLsiv5BcWMeta?.redirect,
    component: () => import("/tmp/build_745d8f7f/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]